import {CommonMessages} from '../common.messages';

export const OperatorPermissionFilterMessages = {
    PersonalInfoAldeadyEditMode: {
        key: 'PersonalInfoAldeadyEditMode',
        message: 'Personal info is already in edit mode! Please save changes.'
    },
    UpdateOperatorPermissionFilterFailed: {
        key: 'UpdateOperatorPermissionFilterFailed',
        message: 'Error while processing request. Unable to update a Permission Filter.'
    },
    ...CommonMessages
};
